
import mixpanel from 'mixpanel-browser';
import TrackingProvider from './tracking-provider';
import { logIt } from '@/services/logger';

class MixpanelProvider extends TrackingProvider {
  constructor(config) {
    super(config);
    this.name = 'Mixpanel';
  }

  init() {
    if (this.config.token) {
      mixpanel.init(this.config.token, {
        track_pageview: false, // We will track manually or let GA handle it primarily if needed, but best to be explicit
        persistence: 'localStorage',
        ...this.config.options
      });
      logIt("log", `[${this.name}] Initialized with Token: ${this.config.token}`);
    } else {
      logIt("Error", `[${this.name}] Token not provided.`);
    }
  }

  track(eventName, properties = {}) {
    logIt("log", `[${this.name}] Track Event: ${eventName}`, properties);
    mixpanel.track(eventName, properties);
  }

  identify(userId, traits = {}) {
    logIt("log", `[${this.name}] Identify User: ${userId}`, traits);
    
    mixpanel.identify(userId);
    
    if (Object.keys(traits).length > 0) {
      mixpanel.people.set(traits);
    }
  }

  page(path, properties = {}) {
    // Mixpanel doesn't have a specific page view method like GA, but we can track it as an event
    logIt("log", `[${this.name}] Page View: ${path}`, properties);
    
    mixpanel.track('Page View', {
      path: path,
      ...properties
    });
  }
}

export default MixpanelProvider;
